import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-work-in-progress',
  templateUrl: './work-in-progress.component.html',
  styleUrls: ['./work-in-progress.component.scss'],
})
export class WorkInProgressComponent implements OnInit {
  textContent = '';

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.textContent = this.route.snapshot.paramMap.get('linkTo') ?? '';
  }
}
